import axios from '@/libs/api.request';
export const webGetAllRegion = data => {
    return axios.request({
        url: 'web/systemManagement/regionManagement/webGetAllRegion',
        data: data,
        method: 'post'
    });
};

export const getRegionCascade = data => {
    return axios.request({
        url: 'api/systemManagement/regionManagement/getRegionCascade',
        data: data,
        method: 'post'
    });
};
